import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _995eb300 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _b55a8224 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5798c5ac = () => interopDefault(import('../../../pages/app/bewertung/index.vue' /* webpackChunkName: "pages/app/bewertung/index" */))
const _7f774feb = () => interopDefault(import('../../../pages/app/einstellungen.vue' /* webpackChunkName: "pages/app/einstellungen" */))
const _1b184581 = () => interopDefault(import('../../../pages/app/evaluation/index.vue' /* webpackChunkName: "pages/app/evaluation/index" */))
const _e9158a9a = () => interopDefault(import('../../../pages/app/forgot-password.vue' /* webpackChunkName: "pages/app/forgot-password" */))
const _3a6210a0 = () => interopDefault(import('../../../pages/app/haftungsausschluss.vue' /* webpackChunkName: "pages/app/haftungsausschluss" */))
const _697ddacd = () => interopDefault(import('../../../pages/app/liveparser.vue' /* webpackChunkName: "pages/app/liveparser" */))
const _02cf6c6a = () => interopDefault(import('../../../pages/app/loading.vue' /* webpackChunkName: "pages/app/loading" */))
const _7cf84997 = () => interopDefault(import('../../../pages/app/login.vue' /* webpackChunkName: "pages/app/login" */))
const _241b10b5 = () => interopDefault(import('../../../pages/app/objekt-radar/index.vue' /* webpackChunkName: "pages/app/objekt-radar/index" */))
const _351ced2a = () => interopDefault(import('../../../pages/app/objekt-radar-evaluation/index.vue' /* webpackChunkName: "pages/app/objekt-radar-evaluation/index" */))
const _674bd2f9 = () => interopDefault(import('../../../pages/app/portfolio/index.vue' /* webpackChunkName: "pages/app/portfolio/index" */))
const _c0665836 = () => interopDefault(import('../../../pages/app/register.vue' /* webpackChunkName: "pages/app/register" */))
const _518bf24e = () => interopDefault(import('../../../pages/app/reset-rassword.vue' /* webpackChunkName: "pages/app/reset-rassword" */))
const _046e32ac = () => interopDefault(import('../../../pages/app/verification-email.vue' /* webpackChunkName: "pages/app/verification-email" */))
const _7b21fe02 = () => interopDefault(import('../../../pages/app/objekt-radar/abonnement.vue' /* webpackChunkName: "pages/app/objekt-radar/abonnement" */))
const _01578936 = () => interopDefault(import('../../../pages/app/objekt-radar/details.vue' /* webpackChunkName: "pages/app/objekt-radar/details" */))
const _211194d6 = () => interopDefault(import('../../../pages/app/objekt-radar/subscription-done.vue' /* webpackChunkName: "pages/app/objekt-radar/subscription-done" */))
const _7f1616be = () => interopDefault(import('../../../pages/app/objekt-radar/testzeitraum_abgelaufen.vue' /* webpackChunkName: "pages/app/objekt-radar/testzeitraum_abgelaufen" */))
const _04623c5b = () => interopDefault(import('../../../pages/app/objekt-radar/testzeitraum_aktivieren.vue' /* webpackChunkName: "pages/app/objekt-radar/testzeitraum_aktivieren" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/app",
    component: _995eb300,
    name: "app___default"
  }, {
    path: "/at",
    component: _b55a8224,
    name: "index___at"
  }, {
    path: "/app/bewertung",
    component: _5798c5ac,
    name: "app-bewertung___default"
  }, {
    path: "/app/einstellungen",
    component: _7f774feb,
    name: "app-einstellungen___default"
  }, {
    path: "/app/evaluation",
    component: _1b184581,
    name: "app-evaluation___default"
  }, {
    path: "/app/forgot-password",
    component: _e9158a9a,
    name: "app-forgot-password___default"
  }, {
    path: "/app/haftungsausschluss",
    component: _3a6210a0,
    name: "app-haftungsausschluss___default"
  }, {
    path: "/app/liveparser",
    component: _697ddacd,
    name: "app-liveparser___default"
  }, {
    path: "/app/loading",
    component: _02cf6c6a,
    name: "app-loading___default"
  }, {
    path: "/app/login",
    component: _7cf84997,
    name: "app-login___default"
  }, {
    path: "/app/objekt-radar",
    component: _241b10b5,
    name: "app-objekt-radar___default"
  }, {
    path: "/app/objekt-radar-evaluation",
    component: _351ced2a,
    name: "app-objekt-radar-evaluation___default"
  }, {
    path: "/app/portfolio",
    component: _674bd2f9,
    name: "app-portfolio___default"
  }, {
    path: "/app/register",
    component: _c0665836,
    name: "app-register___default"
  }, {
    path: "/app/reset-rassword",
    component: _518bf24e,
    name: "app-reset-rassword___default"
  }, {
    path: "/app/verification-email",
    component: _046e32ac,
    name: "app-verification-email___default"
  }, {
    path: "/at/app",
    component: _995eb300,
    name: "app___at"
  }, {
    path: "/app/objekt-radar/abonnement",
    component: _7b21fe02,
    name: "app-objekt-radar-abonnement___default"
  }, {
    path: "/app/objekt-radar/details",
    component: _01578936,
    name: "app-objekt-radar-details___default"
  }, {
    path: "/app/objekt-radar/subscription-done",
    component: _211194d6,
    name: "app-objekt-radar-subscription-done___default"
  }, {
    path: "/app/objekt-radar/testzeitraum_abgelaufen",
    component: _7f1616be,
    name: "app-objekt-radar-testzeitraum_abgelaufen___default"
  }, {
    path: "/app/objekt-radar/testzeitraum_aktivieren",
    component: _04623c5b,
    name: "app-objekt-radar-testzeitraum_aktivieren___default"
  }, {
    path: "/at/app/bewertung",
    component: _5798c5ac,
    name: "app-bewertung___at"
  }, {
    path: "/at/app/einstellungen",
    component: _7f774feb,
    name: "app-einstellungen___at"
  }, {
    path: "/at/app/evaluation",
    component: _1b184581,
    name: "app-evaluation___at"
  }, {
    path: "/at/app/forgot-password",
    component: _e9158a9a,
    name: "app-forgot-password___at"
  }, {
    path: "/at/app/haftungsausschluss",
    component: _3a6210a0,
    name: "app-haftungsausschluss___at"
  }, {
    path: "/at/app/liveparser",
    component: _697ddacd,
    name: "app-liveparser___at"
  }, {
    path: "/at/app/loading",
    component: _02cf6c6a,
    name: "app-loading___at"
  }, {
    path: "/at/app/login",
    component: _7cf84997,
    name: "app-login___at"
  }, {
    path: "/at/app/objekt-radar",
    component: _241b10b5,
    name: "app-objekt-radar___at"
  }, {
    path: "/at/app/objekt-radar-evaluation",
    component: _351ced2a,
    name: "app-objekt-radar-evaluation___at"
  }, {
    path: "/at/app/portfolio",
    component: _674bd2f9,
    name: "app-portfolio___at"
  }, {
    path: "/at/app/register",
    component: _c0665836,
    name: "app-register___at"
  }, {
    path: "/at/app/reset-rassword",
    component: _518bf24e,
    name: "app-reset-rassword___at"
  }, {
    path: "/at/app/verification-email",
    component: _046e32ac,
    name: "app-verification-email___at"
  }, {
    path: "/at/app/objekt-radar/abonnement",
    component: _7b21fe02,
    name: "app-objekt-radar-abonnement___at"
  }, {
    path: "/at/app/objekt-radar/details",
    component: _01578936,
    name: "app-objekt-radar-details___at"
  }, {
    path: "/at/app/objekt-radar/subscription-done",
    component: _211194d6,
    name: "app-objekt-radar-subscription-done___at"
  }, {
    path: "/at/app/objekt-radar/testzeitraum_abgelaufen",
    component: _7f1616be,
    name: "app-objekt-radar-testzeitraum_abgelaufen___at"
  }, {
    path: "/at/app/objekt-radar/testzeitraum_aktivieren",
    component: _04623c5b,
    name: "app-objekt-radar-testzeitraum_aktivieren___at"
  }, {
    path: "/",
    component: _b55a8224,
    name: "index___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
